import { render, staticRenderFns } from "./subTransaction.vue?vue&type=template&id=49248730&scoped=true"
import script from "./subTransaction.vue?vue&type=script&lang=js"
export * from "./subTransaction.vue?vue&type=script&lang=js"
import style0 from "./subTransaction.vue?vue&type=style&index=0&id=49248730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49248730",
  null
  
)

export default component.exports